import { render, staticRenderFns } from "./ActivityMemberApprove.vue?vue&type=template&id=32d6323a&"
import script from "./ActivityMemberApprove.vue?vue&type=script&lang=js&"
export * from "./ActivityMemberApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ActivityMemberApprove.vue"
export default component.exports